/**
 * @desc 历史报告
 */
import React, { PureComponent } from 'react';
import SearchList from './index/SearchList';

export default class Report extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {/* <Tabs defaultActiveKey="search" animated={false} className="line-tabs margin">
                    <TabPane tab="报告搜索" key="search">
                        <SearchList />
                    </TabPane>
                    <TabPane tab="本地上传" key="local">
                        <LocalAnalyze />
                    </TabPane>
                </Tabs>*/}
                <SearchList />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/personal/report/Index.jsx